import { render, staticRenderFns } from "./ActiveChallenges.vue?vue&type=template&id=97e74808&scoped=true"
import script from "./ActiveChallenges.vue?vue&type=script&lang=js"
export * from "./ActiveChallenges.vue?vue&type=script&lang=js"
import style0 from "./ActiveChallenges.vue?vue&type=style&index=0&id=97e74808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e74808",
  null
  
)

export default component.exports